/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  UserVerificationSelectAccount.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			: Aug 29, 2019
*
* @Version      : Version 1.0
*
* Description   : ASDS-1082:Added to Display CheckOut routing URL in browser
******************************************************************************/
import * as React from 'react';
import { StaticContent } from '../../UserVerification';
import { getProperty } from '../../../utils/util';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import SelectAccount from '../SelectAccount/selectAccount';
import { logInfo } from '../../../utils/console-utility';

class UserVerificationSelectAccount extends React.Component<any>{

    constructor(props) {
        super(props);
        this.gotoAdsDashBoard = this.gotoAdsDashBoard.bind(this);
    }

    //Redirects to ADS Dash Board URL
    gotoAdsDashBoard() {
        const redirectURL = getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL);
        logInfo("redirectURL ", redirectURL);
        if (redirectURL) // TODO - remove sessionStorage and LocalStorage values
            window.location.href = redirectURL;
    }

    render() {
        return (
            <React.Fragment>
                <SelectAccount open={true} onClose={this.gotoAdsDashBoard} />
                <StaticContent />
            </React.Fragment>
        );

    }

}

export default UserVerificationSelectAccount;